import { render } from "./DashboardStatsSummary.vue?vue&type=template&id=c3477ef0"
import script from "./DashboardStatsSummary.vue?vue&type=script&lang=js"
export * from "./DashboardStatsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__